import React from 'react'

const ArrowContinue = (props) => (
  <svg width="24"
       height="24"
       fill={props.color ? props.color : '#FFFFFF'}
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 13L16.17 13L12.59 16.59L14 18L20 12L14 6L12.59 7.41L16.17 11L4 11L4 13Z" />
  </svg>
)

export default ArrowContinue
